import React from "react";

export const LineChart33 = ({ x = 0, y = 0 }) => (
  <g style={{ transform: `translate(${x}px, ${y}px)` }}>
    <rect width={92} height={28} rx={1} fill="#F1F2F6" />

    <polyline
      points="6 22 26 6 35 19 52 11 67 16 86 8"
      fill="none"
      stroke="#0787C9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </g>
);
